<template>
  <QuesCard
    :maxwidth="maxwidth"
    :ques="ques"
    :isEdit="isEdit"
    :showIsAssign="true"
    @quesDel="$emit('quesDel')"
  >
    <template slot="title">
      {{ ques.serial == null ? '' : ques.serial + '. ' }}日期時間題
    </template>
    <v-card-text class="text-start" slot="content">
      <template v-if="!isEdit">
        <div v-for="(name, idx) in ques.cnName.split(/\r?\n/)" :key="idx">{{ ques.serial == null ? '' : ques.serial + '. ' }}{{ name }}</div>
        <!-- 加上題號在非編輯狀態 -->
      </template>
      <v-textarea
        v-if="isEdit"
        outlined
        rows="1"
        label="題目內容"
        auto-grow
        v-model="ques.cnName"
        v-on:click="checkDef()"
        class="peter-text"
      ></v-textarea>
      <v-row class="mt-2 ml-0 pr-3">
        <v-file-input
          v-if="isEdit"
          chips
          filled
          class="pt-0"
          v-model="ques.headingFile"
          accept="image/*"
          @change="onImgChangeHeading($event)"
          label="File input"
        >
        </v-file-input>
      </v-row>
      <v-row>
        <v-col class="pa-0 text-center" >
          <!-- <v-img></v-img> 改成 <img> 來顯示圖片原始的最大尺寸 max-width控制不破圖 -->
          <img
            v-if="ques.questHeadingPic"
            :src="
              ques.questHeadingPic.startsWith('data')
                ? ques.questHeadingPic
                : $store.state.server + ques.questHeadingPic
            "
            style="max-width: 100%"
          />
        </v-col>
      </v-row>

      
      <v-dialog
        ref="dialog"
        v-model="modal"
        :return-value.sync="ques.value"
        persistent
        width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="ques.value"
            prepend-icon="event"
            readonly
            v-on="on"
            class="peter-text"
          ></v-text-field>
        </template>
        <v-date-picker
          v-show="selectingDate"
          v-model="date"
          scrollable
          @change="dateSelected()"
        >
        </v-date-picker>
        <v-time-picker v-show="!selectingDate" v-model="time" scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
          <v-btn text color="primary" @click="timeSelected()">OK</v-btn>
        </v-time-picker>
      </v-dialog>
    </v-card-text>
  </QuesCard>
</template>

<script>
import QuesCard from './QuesCard'
export default {
  components: {
    QuesCard,
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    maxwidth: {
      type: Number,
      default: null,
    },
    ques: {
      type: Object,
      default: () => {
        return {
          title: '日期題',
          cnName: '日期題題目內容',
          value: null,
        }
      },
    },
  },
  // 監聽日期、時間變化時即時更新到 ques.value
  watch: {
    date(newValue, oldValue) {
      this.ques.value = this.date + ' ' + this.time
    },
    time(newValue, oldValue) {
      this.ques.value = this.date + ' ' + this.time
    },
  },
  data() {
    return {
      modal: false, // dialog 是否出現
      selectingDate: true, // selectingDate 決定 dialog 要顯示 date-picker(true) 或 time-picker(false)
      date: '', // datepicker  bind value
      time: '', // timepicker bind value
    }
  },
  computed: {
    QType() {
      return this.$store.state.QType
    },
  },
  methods: {
    onImgChangeHeading(file) {
      if (!file) {
        this.ques.questHeadingPic = null
      } else {
        var fileReader = new FileReader()
        fileReader.addEventListener('load', (e) => {
          this.ques.questHeadingPic = e.target.result
        })
        fileReader.readAsDataURL(file)
      }
    },
    // 當日期被選中時的動作
    dateSelected() {
      this.selectingDate = false // 切換為顯示 date-picker
    },
    // 當時間被選中時的動作
    timeSelected() {
      this.selectingDate = true // 切換為顯示 time-picker
      this.$refs.dialog.save(this.ques.value) // 收起 dialog
    },
    checkDef() {
      if (this.QType.DATE_TIME.template.cnName === this.ques.cnName) {
        this.ques.cnName = ''
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.thiscard {
  border-radius: 10px;
  cursor: grab;
}
</style>
